// src/components/store/sections/newsletter/NewsletterV2SplitCardViolet.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV2SplitCardViolet(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={2}
      archKey="split_card"
      archLabel="Floating Split Card"
      palName="RoyalViolet"
      grad="from-violet-600 via-purple-600 to-indigo-700"
      lightBg="bg-violet-50"
      textCol="text-violet-700"
      borderCol="border-violet-200"
      btnCls="bg-violet-600 hover:bg-violet-700"
      hexCol="#8b5cf6"
      {...props}
    />
  );
}
